import { ref } from "vue";
import { isOverflown } from "@/Utils/overflow";

export const useOverflow = () => {
    const elementIsOverflown = ref(false);

    const checkIfOverflown = (property, element) => {
        setTimeout(() => {
            if (!element) {
                elementIsOverflown.value = false;
            } else {
                if (property === "linked_to") {
                    let linkedToElement = Array.from(
                        element.$el.childNodes
                    ).findLast(
                        (node) => node.style && node.style.display !== "none"
                    );
                    elementIsOverflown.value =
                        linkedToElement.childElementCount > 1
                            ? isOverflown(element.$el)
                            : isOverflown(
                                  linkedToElement,
                                  linkedToElement.firstElementChild
                              );
                } else {
                    elementIsOverflown.value = isOverflown(element.$el);
                }
            }
        });
    };

    return {
        checkIfOverflown,
        elementIsOverflown,
    };
};
